export { AvatarCore } from './AvatarCore';
export type { AvatarCoreProps } from './AvatarCore';
